export const EXPLICIT_LOGOUT_SESSION_KEY = 'adminPortal:explicitLogout'

export const isExplicitlyLoggedOut = () =>
  typeof window !== 'undefined' && sessionStorage.getItem(EXPLICIT_LOGOUT_SESSION_KEY) === 'true'
